import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class CategoryApiClient extends AdvancedApiClient {

    static entityType = "WooCommerceCategory"

    constructor(token, channelId) {
        super();

        this.setEntityType(CategoryApiClient.entityType)
            .setRoute("/api/v1/channel/{id}/woocommerce/category")
            .setRouteParam("id", channelId);
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}